import { FusaReply } from '@/types/replyTypes';
import { AssistantMessage, AssistantStreamEvent } from '@/types/reportAssistantTypes';
import { CreateSchemaRequest, PublishSchemaRequest, SaveSchemaDraftRequest, SchemaListResponse, SchemaResponse, SchemaVersionResponse, UpdateSchemaRequest } from '@/types/schemaTypes';
import { Client } from './client';

/** Schemas: the input sheets report bundles read, authored by Fusaware staff. */
export class SchemaFrontendController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  list(): Promise<SchemaListResponse> {
    return this.client.read('/api/schemas');
  }

  create(data: CreateSchemaRequest): Promise<SchemaResponse> {
    return this.client.create('/api/schemas', data);
  }

  read(id: string): Promise<SchemaResponse> {
    return this.client.read(`/api/schemas/${id}`);
  }

  update(id: string, data: UpdateSchemaRequest): Promise<SchemaResponse> {
    return this.client.patch(`/api/schemas/${id}`, data);
  }

  saveDraft(id: string, data: SaveSchemaDraftRequest): Promise<SchemaResponse> {
    return this.client.update(`/api/schemas/${id}/draft`, data);
  }

  publish(id: string, data: PublishSchemaRequest = {}): Promise<SchemaVersionResponse> {
    return this.client.create(`/api/schemas/${id}/versions`, data);
  }

  delete(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/schemas/${id}`);
  }

  /** one reply of the schema's assistant, its events as they stream; the refusal when the server would not start one */
  assistantReply(id: string, messages: AssistantMessage[], onEvent: (event: AssistantStreamEvent) => void, signal?: AbortSignal): Promise<FusaReply | null> {
    return this.client.postEventStream(`/api/schemas/${id}/assistant`, { messages }, (data) => onEvent(JSON.parse(data) as AssistantStreamEvent), signal);
  }
}
